<template>
  <div class="content fade-in superadmin-settings">
    <transition name="fade-slide">
      <div v-if="loading" class="global-loader">
        <div class="loader-spinner"></div>
        <p>Loading...</p>
      </div>
    </transition>
    <!-- 🔹 MAIN TABS -->
    <div class="tabs-container sticky-tabs">
      <button
        v-for="t in tabs"
        :key="t"
        class="tab-item"
        :class="{ active: activeTab === t }"
        @click="activeTab = t"
      >
        {{ t }}
      </button>
    </div>

    <!-- =========================================================
         🧱 1. SYSTEM SETTINGS
    ========================================================== -->
    <div v-if="activeTab === 'System Settings'" class="settings-section">
      <div class="grid-2">
        <!-- Application Settings -->
        <div class="card">
          <h3><i class="bx bx-cog"></i> Application Settings</h3>
          <div class="form-grid" style="margin-top: 1rem;">
            <div class="form-group">
              <label>App Name</label>
              <input type="text" v-model="system.appName" placeholder="AI Business Manager" />
            </div>
            <div class="form-group">
              <label>Logo</label>
              <input type="file" @change="handleLogoUpload" placeholder="app.example.com" />
            </div>
          </div>

          <div class="form-grid" style="margin-top: 1rem;">
            <div class="form-group">
              <label>Favicon</label>
              <input type="file"  @change="handleFavUpload" placeholder="app.example.com" />
            </div>
          </div>

          <div class="form-grid" style="margin-top: 1rem;">
            
            <div class="form-group">
              <label>Date Format</label>
              <select v-model="system.dateFormat">
                <option value="DD MMM YYYY">DD MMM YYYY</option>
                <option value="YYYY-MM-DD">YYYY-MM-DD</option>
                <option value="MM/DD/YYYY">MM/DD/YYYY</option>
              </select>
            </div>
          </div>

          <div class="button-row" style="margin-top: 2rem;">
            <button class="btn-secondary" @click="resetSystem"><i class="bx bx-rotate-left"></i> Reset</button>
            <button class="btn-primary" @click="saveSystem"><i class="bx bx-save"></i> Save Settings</button>
          </div>
        </div>

        <!-- SMTP -->
        <!-- <div class="card">
          <h3><i class="bx bx-envelope"></i> Email & SMTP</h3>
          <div class="form-grid" style="margin-top: 1rem;">
            <div class="form-group">
              <label>From Name</label>
              <input type="text" v-model="smtp.fromName" placeholder="AI Business Manager" />
            </div>
            <div class="form-group">
              <label>From Email</label>
              <input type="email" v-model="smtp.fromEmail" placeholder="no-reply@example.com" />
            </div>
          </div>

          <div class="form-grid" style="margin-top: 1rem;">
            <div class="form-group">
              <label>SMTP Host</label>
              <input type="text" v-model="smtp.host" placeholder="smtp.example.com" />
            </div>
            <div class="form-group">
              <label>SMTP Port</label>
              <input type="number" v-model="smtp.port" placeholder="587" />
            </div>
          </div>

          <div class="form-grid" style="margin-top: 1rem;">
            <div class="form-group">
              <label>Username</label>
              <input type="text" v-model="smtp.username" placeholder="SMTP User" />
            </div>
            <div class="form-group">
              <label>Password</label>
              <input :type="showSmtpPass ? 'text' : 'password'" v-model="smtp.password" placeholder="••••••••" />
            </div>
          </div>

          <div class="inline-actions" style="margin-top: 2rem;">
           
            <button class="btn-secondary" @click="testEmail"><i class="bx bx-paper-plane"></i> Test</button>
            <button class="btn-primary" @click="saveSmtp"><i class="bx bx-save"></i> Save</button>
          </div>
        </div> -->
      </div>
    </div>

    <!-- =========================================================
         🤖 2. AI / API CONTROL PANEL (Tabbed)
    ========================================================== -->
    <div v-if="activeTab === 'AI / API Control Panel'" class="settings-section">

      <!-- SUBTABS -->
      <div class="subtabs">
        <button
          v-for="st in aiTabs"
          :key="st.key"
          class="subtab-item"
          :class="{ active: activeAiTab === st.key }"
          @click="activeAiTab = st.key"
        >
          <i :class="st.icon"></i> {{ st.label }}
        </button>
      </div>

      <!-- === AI Integrations === -->
      <div v-if="activeAiTab === 'ai'" class="card fade-in">
        <h3><i class="bx bx-brain"></i> ChatGPT / OpenAI Configuration</h3>

        <div class="form-grid" style="margin-top: 1rem;">
          <div class="form-group">
            <label>API Key</label>
            <div class="input-with-action">
              <input :type="revealOpenAi ? 'text' : 'password'" v-model="openai.key" placeholder="sk-••••••••" />
              <button class="icon-btn" @click="revealOpenAi = !revealOpenAi">
                <i class="bx" :class="revealOpenAi ? 'bx-hide' : 'bx-show'"></i>
              </button>
              <button class="icon-btn danger" @click="rotateOpenAiKey">
                <i class="bx bx-refresh"></i>
              </button>
            </div>
          </div>

          <div class="form-group">
            <label>Default Model</label>
            <select v-model="openai.model">
              <option>gpt-4o</option>
              <option>gpt-4o-mini</option>
              <option>gpt-4.1</option>
              <option>gpt-3.5-turbo</option>
            </select>
          </div>
        </div>

        <div class="form-grid" style="margin-top: 1rem;">
          <div class="form-group">
            <label>Monthly Usage Limit ($)</label>
            <input type="number" v-model="openai.limit" placeholder="5000" />
          </div>
          <div class="form-group">
            <label>Timeout (ms)</label>
            <input type="number" v-model="openai.timeout" placeholder="30000" />
          </div>
        </div>

        <div class="inline-actions" style="margin-top: 2rem;">
         
          <div class="spacer"></div>
          <button class="btn-primary" @click="saveOpenAi"><i class="bx bx-save"></i> Save</button>
        </div>
      </div>

      <!-- === Payment Gateways === -->
      <div v-if="activeAiTab === 'payment'" class="card fade-in">
        <h3><i class="bx bx-credit-card"></i> Payment Gateway Keys</h3>
        <div class="form-grid" style="margin-top: 1rem;">
          <div
            v-for="pg in paymentGateways"
            :key="pg.key"
            class="form-group gateway-group"
          >
            <label><i :class="pg.icon"></i> {{ pg.label }}</label>
            <div class="input-with-action">
              <label v-if="pg.label==='Razorpay' || pg.label==='PayPal'">Key</label>
              <input :type="pg.show ? 'text' : 'password'" v-model="pg.keyValue" placeholder="••••••••" />
              <button class="icon-btn" @click="pg.show = !pg.show">
                <i class="bx" :class="pg.show ? 'bx-hide' : 'bx-show'"></i>
              </button>
            </div>
            <div class="input-with-action" v-if="pg.label==='Razorpay' || pg.label==='PayPal'" style="margin-top: 1rem;">
              <label>Secret</label>
              <input :type="pg.show1 ? 'text' : 'password'" v-model="pg.keyValue1" placeholder="••••••••" />
              <button class="icon-btn" @click="pg.show1 = !pg.show1">
                <i class="bx" :class="pg.show1 ? 'bx-hide' : 'bx-show'"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="button-row" style="margin-top: 2rem;">
          <button class="btn-primary" @click="saveGateways"><i class="bx bx-save"></i> Save Keys</button>
        </div>
      </div>

     
    </div>

  

<TemplateModal
  v-if="showNotifModal"
  title="Add Notification Template"
  @close="showNotifModal = false"
  @save="saveTemplate"
  :form="templateForm"
  :userId="userId"
  tempType="notification"
/>
<ConfirmDialog
  :show="confirmBox.show"
  :title="confirmBox.title"
  :message="confirmBox.message"
  @cancel="confirmBox.show = false"
  @confirmAction="executeConfirm"
/>

  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import { getAdminSettings,saveAdminSettings,getAiPgSettings,saveAiPgSettings } from "@/apis/aupadminapis";
import TemplateModal from "@/comps/TemplateModal.vue";
import ConfirmDialog from "@/comps/ConfirmDialog.vue";
import {
  getTemplates,
  createTemplate,
  deleteTemplate,
} from "@/apis/adminapis";
export default {
  name: "SuperAdminSettings",
  components:{
    TemplateModal,
    ConfirmDialog
  },
  data() {
    return {
      confirmBox: {
        show: false,
        title: "",
        message: "",
        onConfirm: null
      },
      userId:"",
      loaderText:"",
      loading:false,
      showNotifModal: false,
      templateForm: {
        temp_id: "",
        temp_title: "",
        temp_desc: "",
        temp_cat:"",
        temp_type: "",
      },
      pagination: {
  total: 0,
  per_page: 10,
  page: 0, // page_no starts from 0 in CI4
},
      /* ===== MAIN TABS ===== */
      activeTab: "System Settings",
      toast:useToast(),
      tabs: [
        "System Settings",
        "AI / API Control Panel"
      ],

      /* ===== SUBTABS (AI / API) ===== */
      activeAiTab: "ai",
      aiTabs: [
        { key: "ai", label: "ChatGPT / AI", icon: "bx bx-brain" },
        { key: "payment", label: "Payment Gateways", icon: "bx bx-credit-card" }
      ],

      /* ===== System Settings ===== */
      system: {
        appName: "AI Business Manager",
        logo: null,
        fav: null,
        dateFormat: "DD MMM YYYY",
      },

      /* ===== SMTP ===== */
      smtp: {
        fromName: "AI Business Manager",
        fromEmail: "no-reply@example.com",
        host: "smtp.example.com",
        port: 587,
        username: "smtp-user",
        password: "",
        secure: true,
      },
      showSmtpPass: false,

      /* ===== OpenAI / ChatGPT ===== */
      openai: {
        key: "",
        model: "gpt-4o",
        limit: 5000,
        timeout: 30000,
        enabled: true,
      },
      revealOpenAi: false,

      /* ===== Payment Gateways ===== */
      paymentGateways: [
        {
          key: "razorpay",
          label: "Razorpay",
          icon: "bx bx-money",
          keyValue: "",
          keyValue1: "",
          show: false,
          show1: false,
        },
        {
          key: "paypal",
          label: "PayPal",
          icon: "bx bx-money",
           keyValue1: "",
          keyValue: "",
          show: false,
          show1: false,
        },
        {
          key: "stripe",
          label: "Stripe",
          icon: "bx bx-credit-card",
          keyValue: "",
          show: false,
        },
      ],

     
      revealApiKey: false,

      /* ===== Notifications ===== */
      notif: { enabled: true },
      templateQuery: "",
      templates: [
        { id: 1, name: "Welcome Email", trigger: "User Signup" },
        { id: 2, name: "Password Reset", trigger: "Forgot Password" },
        { id: 3, name: "Payment Failed", trigger: "Billing Issue" },
        { id: 4, name: "Invoice Paid", trigger: "Payment Success" },
      ],

    };
  },
mounted() {
  const ldata = JSON.parse(sessionStorage.getItem("ldata")) || {};
  if(ldata!=null && ldata!=undefined){
    this.userId = ldata.user_id;
    this.loadTemplates("notification", 0);
    this.loadAdminSettings();
    this.loadAiPgSettings();
  }
},
 
  watch:{
    templateQuery(val) {
      console.log("sad",val);
    this.loadTemplates("notification", 0);
  }
  },
  methods: {
     handleLogoUpload(event) {
      const file = event.target.files[0];
      this.system.logo = file;
      console.log("Selected File:", file);
    },
    handleFavUpload(event) {
      const file = event.target.files[0];
      this.system.fav = file;
      console.log("Selected File:", file);
    },
    openConfirm(title, message, callback) {
      this.confirmBox = {
        show: true,
        title,
        message,
        onConfirm: callback
      };
    },

    executeConfirm() {
      if (this.confirmBox.onConfirm) {
        this.confirmBox.onConfirm();
      }
      this.confirmBox.show = false;
    },

   async loadAdminSettings() {
  try {
    this.loading = true;

    const res = await getAdminSettings();

    if (res.status && res.settings) {
      const s = res.settings;

      // 🌐 System Settings Mapping
      this.system = {
        appName: s.app_name,
        logo: null,
        fav:null,
        dateFormat: s.date_format,
      };

      // 📧 SMTP Mapping
      this.smtp = {
        fromName: s.from_name,
        fromEmail: s.from_email,
        host: s.smtp_host,
        port: Number(s.smtp_port),
        username: s.smtp_username,
        password: s.smtp_password,
        secure: s.smtp_secure == "1",
      };
    }
  } catch (err) {
    console.error("loadAdminSettings error:", err);
  } finally {
    this.loading = false;
  }
}

,
async loadAiPgSettings() {
  try {
    this.loading = true;

    const res = await getAiPgSettings();

    if (res.status && res.settings) {
      const s = res.settings;

      // 🧠 AI Settings
      this.openai = {
        key: s.api_key || "",
        model: s.default_model || "gpt-4o",
        limit: Number(s.monthly_usage_limit) || 0,
        timeout: Number(s.timeout_ms) || 30000,
        enabled: s.enable_ai_features == "1",
      };

      // 💳 Payment Gateways
      this.paymentGateways[0].keyValue = s.razorpay_key || "";
      this.paymentGateways[0].keyValue1 = s.razorpay_seceret || "";
      this.paymentGateways[1].keyValue = s.paypal_key || "";
      this.paymentGateways[1].keyValue1 = s.paypal_seceret || "";
      this.paymentGateways[2].keyValue = s.stripe_key || "";
    }

  } catch (err) {
    console.error("loadAiPgSettings error:", err);
  } finally {
    this.loading = false;
  }
}

,
    /* ===== SYSTEM SETTINGS ===== */
    async resetSystem() {
      try {
        this.loading = true; // 🔹 Show Loader

        // 🔸 Optionally create object with defaults (your initial values)
        this.system = {
          appName: "AI Business Manager",
          fav: null,
          logo: null,
          
          dateFormat: "DD MMM YYYY",
        };

        this.smtp = {
          fromName: "AI Business Manager",
          fromEmail: "no-reply@example.com",
          host: "smtp.example.com",
          port: 587,
          username: "smtp-user",
          password: "",
          secure: true,
        };

        // 🔹 Simulate slight delay for better UX
        await new Promise((resolve) => setTimeout(resolve, 400));

        this.toast.success("System settings reset successfully");

      } catch (error) {
        console.error("resetSystem error:", error);
      } finally {
        this.loading = false; // 🔹 Hide Loader
      }
    }
    ,
   async saveSystem() {
      try {
        if (!this.system.appName.trim()) {
      this.toast.warning("App name is required");
      return;
    }
   
    
    if (!this.system.dateFormat) {
      this.toast.warning("Date format is required");
      return;
    }

        this.loading = true; // 🔹 Show loader

        const res = await saveAdminSettings(
          this.system.appName,
          this.system.logo,
          this.system.fav,
          this.system.dateFormat,

          // SMTP section
          this.smtp.fromName,
          this.smtp.fromEmail,
          this.smtp.host,
          this.smtp.port,
          this.smtp.username,
          this.smtp.password,
          this.smtp.secure ? 1 : 0,

          this.userId // or your stored user id
        );

        if (res.status) {
          this.toast.success(res.success || "System settings saved successfully");
        } else {
          this.toast.error(res.success || "Failed to save system settings");
        }
      } catch (error) {
        console.error("saveSystem error:", error);
        this.toast.error("Something went wrong while saving settings");
      } finally {
        this.loading = false; // 🔹 Hide loader
      }
    }
    ,

    /* ===== SMTP ===== */
    testEmail() {
      alert("Test email sent using provided SMTP credentials.");
    },
    async saveSmtp() {
      try {

         if (!this.smtp.fromName.trim()) {
      this.toast.warning("From name is required");
      return;
    }
    if (!this.smtp.fromEmail.trim()) {
      this.toast.warning("From email is required");
      return;
    }
    if (!this.smtp.host.trim()) {
      this.toast.warning("SMTP host is required");
      return;
    }
    if (!this.smtp.port) {
      this.toast.warning("SMTP port is required");
      return;
    }
    if (!this.smtp.username.trim()) {
      this.toast.warning("SMTP username is required");
      return;
    }

        this.loading = true; // 🔹 Show loader

        const res = await saveAdminSettings(
          this.system.appName,
          this.system.logo,
          this.system.fav,
          this.system.dateFormat,

          // 🔹 SMTP fields
          this.smtp.fromName,
          this.smtp.fromEmail,
          this.smtp.host,
          this.smtp.port,
          this.smtp.username,
          this.smtp.password,
          this.smtp.secure ? 1 : 0,

          this.userId // or logged-in admin ID
        );

        if (res.status) {
          this.toast.success(res.success || "SMTP settings updated successfully");
        } else {
          this.toast.error(res.success || "Failed to update SMTP settings");
        }
      } catch (error) {
        console.error("saveSmtp error:", error);
      } finally {
        this.loading = false; // 🔹 Hide loader
      }
    }
    ,

    /* ===== AI / ChatGPT ===== */
    testOpenAi() {
      alert("OpenAI API test executed successfully.");
    },
    async saveOpenAi() {
      try {
    // 🔹 Validations
    if (!this.openai.key.trim()) {
      this.toast.warning("OpenAI API key is required");
      return;
    }
    if (!this.openai.model.trim()) {
      this.toast.warning("OpenAI model is required");
      return;
    }
    if (!this.openai.limit || this.openai.limit < 100) {
      this.toast.warning("Monthly usage limit must be at least 100");
      return;
    }
    if (!this.openai.timeout || this.openai.timeout < 5000) {
      this.toast.warning("Timeout must be at least 5000ms");
      return;
    }


        this.loading = true; // 🔹 Show loader

        const res = await saveAiPgSettings(
          this.openai.key,
          this.openai.model,
          this.openai.limit,
          this.openai.timeout,
          this.openai.enabled ? 1 : 0,

          // 🔹 Payment gateway keys (send current values)
          this.paymentGateways[0].keyValue, // razorpay_key
          this.paymentGateways[0].keyValue1, // razorpay_seceret
          this.paymentGateways[1].keyValue, // paypal_key
          this.paymentGateways[1].keyValue1, // paypal_seceret
          this.paymentGateways[2].keyValue, // stripe_key

          this.userId // updated_by
        );

        if (res.status) {
          this.toast.success(res.success || "ChatGPT configuration saved successfully");
        } else {
          this.toast.error(res.success || "Failed to save ChatGPT settings");
        }
      } catch (error) {
        console.error("saveOpenAi error:", error);
      } finally {
        this.loading = false; // 🔹 Hide loader
      }
    }
    ,
    rotateOpenAiKey() {
      this.openai.key = "";
      alert("Old API key revoked. Please set a new one.");
    },

   
   async saveGateways() {
  try {
     if (!this.paymentGateways[0].keyValue.trim()) {
      this.toast.warning("Razorpay key is required");
      return;
    }
    if (!this.paymentGateways[1].keyValue.trim()) {
      this.toast.warning("PayPal key is required");
      return;
    }
    if (!this.paymentGateways[2].keyValue.trim()) {
      this.toast.warning("Stripe key is required");
      return;
    }

    this.loading = true; // 🔹 Show loader

    const res = await saveAiPgSettings(
      // 🔹 AI settings (must be sent together)
      this.openai.key,
      this.openai.model,
      this.openai.limit,
      this.openai.timeout,
      this.openai.enabled ? 1 : 0,

      // 🔹 Payment Gateways
      this.paymentGateways[0].keyValue, // razorpay_key
      this.paymentGateways[0].keyValue1, // razorpay_seceret
      this.paymentGateways[1].keyValue, // paypal_key
      this.paymentGateways[1].keyValue1, // paypal_seceret
      this.paymentGateways[2].keyValue, // stripe_key

      this.userId // updated_by
    );

    if (res.status) {
      this.toast.success(res.success || "Payment gateway API keys saved successfully");
    } else {
      this.toast.error(res.success || "Failed to save payment gateway keys");
    }
  } catch (error) {
    console.error("saveGateways error:", error);
  } finally {
    this.loading = false; // 🔹 Hide loader
  }
}
,

    /* ===== EMAIL TEMPLATES ===== */
    addTemplate() {
      this.showNotifModal = true;
    },
    editTemplate(t) {
  this.templateForm = {
    temp_id: t.temp_id,
    temp_title: t.temp_title,
    temp_desc: t.temp_desc,
    temp_cat: t.temp_cat,
    temp_type: "notification"
  };

  this.showNotifModal = true;
}
,
   async saveTemplate(formData) {
  if (!formData.temp_title.trim()) {
    this.toast.warning("Template title required");
    return;
  }

  this.loading = true;
  this.loaderText = "Saving template...";

  try {
    formData.temp_user = this.userId;

    const res = await createTemplate(formData);

    if (res.status) {
      this.toast.success(res.success || "Template saved");
      this.showNotifModal = false;

      // reload both categories (if required)
      await this.loadTemplates("notification", 0);

    } else {
      this.toast.error(res.success || "Failed to save template");
    }

  } catch (err) {
    console.error("saveTemplate error:", err);
  } finally {
    this.loading = false;
  }
}
,
async removeTemplate(temp_id) {
    this.openConfirm(
    "Delete Template?",
    "Are you sure you want to delete this template permanently?",
    () => this.deleteTemplateAction(temp_id)
  );
},
async deleteTemplateAction(temp_id){
   this.loading = true;
  this.loaderText = "Deleting template...";

  try {
    const res = await deleteTemplate(temp_id);

    if (res.status) {
      this.toast.success(res.success);
      await this.loadTemplates("notification", 0);
    } else {
      this.toast.error(res.success || "Failed to delete template");
    }

  } catch (err) {
    console.error("removeTemplate error:", err);
  } finally {
    this.loading = false;
  }
}
,
async loadTemplates(type = "notification", page = 0) {
  try {
    this.loading = true;
const ldata = JSON.parse(sessionStorage.getItem("ldata")) || {};
    const res = await getTemplates(
      ldata.user_id, // temp_user
      page,                     // page_no
      type,                     // temp_type
      "",                       // temp_cat
      this.templateQuery        // search_key
    );

    if (res.status) {
      this.templates = res.records || [];
      
    } else {
      this.templates = [];
    }

  } catch (err) {
    console.error("loadTemplates error:", err);
  } finally {
    this.loading = false;
  }
}
,
    previewTemplate(t) {
      alert(`Previewing template: ${t.name}`);
    },
    sendTest(t) {
      alert(`Test email for ${t.name} sent.`);
    },

  },
};
</script>
<style scoped>
/* ===== Page Base ===== */
.superadmin-settings {
  display: flex;
  flex-direction: column;
  gap: 22px;
  padding-bottom: 40px;
}

/* ===== Top Tabs ===== */
.tabs-container {
  display: flex;
  gap: 10px;
  border-bottom: 1px solid var(--border);
  padding-bottom: 6px;
  position: sticky;
  top: 0;
  background: var(--bg, #fff);
  z-index: 5;
  overflow-x: auto;
  scrollbar-width: none;
}
.tabs-container::-webkit-scrollbar {
  display: none;
}
.tab-item {
  border: none;
  background: #f3f4f6;
  color: var(--text);
  padding: 9px 15px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 13.5px;
  cursor: pointer;
  transition: all 0.25s ease;
  white-space: nowrap;
}
.tab-item.active {
  background: var(--primary);
  color: #fff;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.25);
}
.tab-item:hover:not(.active) {
  background: #e5e7eb;
}

/* ===== Section ===== */
.settings-section {
  display: flex;
  flex-direction: column;
  gap: 24px;
  animation: fadeInUp 0.4s ease forwards;
  opacity: 0;
  transform: translateY(8px);
}
@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ===== Cards & Layout ===== */
.card {
  background: var(--card, #fff);
  border: 1px solid var(--border);
  border-radius: var(--radius, 10px);
  padding: 20px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
}
.card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}
.grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}
@media (max-width: 1024px) {
  .grid-2 {
    grid-template-columns: 1fr;
  }
}

/* ===== Form Layout ===== */
.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 14px;
}
.form-group label {
  display: block;
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 6px;
}
.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 9px 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  font-size: 13px;
  background: #fff;
  color: var(--text);
  transition: all 0.25s ease;
}
.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);
}

/* ===== Inline Actions ===== */
.inline-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 12px;
}
.spacer {
  flex: 1;
}

/* ===== Buttons ===== */
.btn-primary,
.btn-secondary,
.btn-outline {
  border: none;
  border-radius: 8px;
  padding: 8px 15px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.btn-primary {
  background: var(--primary);
  color: #fff;
  box-shadow: 0 3px 10px rgba(37, 99, 235, 0.25);
}
.btn-primary:hover {
  background: var(--primary-dark, #1e40af);
  transform: translateY(-2px);
}
.btn-secondary {
  background: #f3f4f6;
  color: var(--text);
}
.btn-secondary:hover {
  background: #e5e7eb;
}
.btn-outline {
  background: #fff;
  color: var(--text);
  border: 1px solid var(--border);
}
.btn-outline:hover {
  border-color: var(--primary);
  color: var(--primary);
}

/* ===== Switch ===== */
.switch {
  position: relative;
  width: 42px;
  height: 22px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  background: #d1d5db;
  border-radius: 22px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: 0.3s;
}
.slider:before {
  content: "";
  position: absolute;
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 3px;
  background: #fff;
  border-radius: 50%;
  transition: 0.3s;
}
input:checked + .slider {
  background: var(--primary);
}
input:checked + .slider:before {
  transform: translateX(20px);
}

/* ===== Usage Boxes ===== */
.usage-row {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 6px;
}
.usage-box {
  flex: 1 1 120px;
  background: #f9fafb;
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 14px;
  text-align: center;
  transition: all 0.25s ease;
}
.usage-box:hover {
  background: #f3f4f6;
  transform: translateY(-2px);
}
.usage-box .label {
  font-size: 12px;
  color: var(--muted);
}
.usage-box strong {
  font-size: 18px;
  color: var(--text);
}

/* ===== AI / API Subtabs ===== */
.ai-subtabs {
  display: flex;
  gap: 10px;
  border-bottom: 1px solid var(--border);
  padding-bottom: 6px;
  overflow-x: auto;
  scrollbar-width: none;
}
.ai-subtabs::-webkit-scrollbar {
  display: none;
}
.ai-subtab {
  background: #f9fafb;
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text);
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.25s ease;
}
.ai-subtab i {
  font-size: 1rem;
  color: var(--primary);
}
.ai-subtab.active {
  background: var(--primary);
  color: #fff;
  border-color: var(--primary);
}
.ai-subtab:hover:not(.active) {
  background: #f3f4f6;
}

/* ===== Template List ===== */
.template-list {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.template-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--border);
  padding: 8px 0;
}
.template-item h4 {
  margin: 0;
  font-size: 14px;
}
.row-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

/* ===== Pagination ===== */
.pagination-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}
.pagination-info {
  font-size: 12px;
  color: var(--muted);
}

/* ===== Responsive ===== */
@media (max-width: 768px) {
  .card {
    padding: 16px;
  }
  .form-group label {
    font-size: 12.5px;
  }
  .form-group input,
  .form-group select {
    font-size: 12.5px;
  }
  .tab-item {
    font-size: 12.5px;
    padding: 7px 12px;
  }
  .btn-primary,
  .btn-secondary,
  .btn-outline {
    font-size: 12.5px;
    padding: 8px 12px;
  }
  .ai-subtabs {
    flex-wrap: nowrap;
  }
  .ai-subtab {
    font-size: 12.5px;
    padding: 6px 10px;
  }
}
/* ==========================================================
   🧠 AI / API CONTROL PANEL - INTERNAL SUBTABS (MATCHES YOUR CODE)
   ========================================================== */

.subtabs {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 18px;
  background: var(--card, #fff);
  border: 1px solid var(--border, #e5e7eb);
  border-radius: 10px;
  padding: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}

/* Subtab Buttons */
.subtab-item {
  flex: 1 1 auto;
  background: #f9fafb;
  border: 1px solid var(--border, #e5e7eb);
  border-radius: 8px;
  padding: 10px 14px;
  font-weight: 600;
  font-size: 13.5px;
  color: var(--text, #1f2937);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.25s ease;
  text-align: center;
  min-width: 160px;
  position: relative;
}

.subtab-item i {
  font-size: 1.2rem;
  color: var(--primary, #2563eb);
  transition: transform 0.3s ease, color 0.3s ease;
}

.subtab-item:hover {
  background: #eef2ff;
  border-color: var(--primary, #2563eb);
  color: var(--primary, #2563eb);
  transform: translateY(-2px);
}

.subtab-item:hover i {
  color: var(--primary, #2563eb);
  transform: scale(1.15);
}

/* Active State */
.subtab-item.active {
  background: var(--primary, #2563eb);
  border-color: var(--primary-dark, #1d4ed8);
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);
}

.subtab-item.active i {
  color: #fff;
  transform: scale(1.1);
}

/* Animated Bottom Line */
.subtab-item::after {
  content: "";
  position: absolute;
  bottom: 5px;
  left: 10%;
  width: 0;
  height: 2px;
  background: #fff;
  transition: width 0.3s ease;
  border-radius: 1px;
}

.subtab-item.active::after {
  width: 80%;
}

/* === Mobile Responsiveness === */
@media (max-width: 768px) {
  .subtabs {
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: thin;
    -ms-overflow-style: none;
  }
  .subtabs::-webkit-scrollbar {
    display: none;
  }

  .subtab-item {
    flex: 0 0 auto;
    white-space: nowrap;
    padding: 8px 12px;
    font-size: 13px;
    min-width: auto;
  }
}

/* === Fade Animation for Tab Content === */
.subtab-content {
  animation: fadeInUp 0.4s ease forwards;
  opacity: 0;
  transform: translateY(6px);
}

@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/* ======================================================
   🌐 AI / API CONTROL PANEL - SUBTABS MISSING CSS
   (For .subtabs and .subtab-item structure)
   ====================================================== */

/* === Subtab Container === */
.subtabs {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  margin-bottom: 18px;
  background: var(--card, #ffffff);
  border: 1px solid var(--border, #e5e7eb);
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

/* === Subtab Buttons === */
.subtab-item {
  flex: 1 1 auto;
  background: #f9fafb;
  border: 1px solid var(--border, #e5e7eb);
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 13.5px;
  font-weight: 600;
  color: var(--text, #1f2937);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all 0.25s ease;
  text-align: center;
  min-width: 160px;
  position: relative;
}

.subtab-item i {
  font-size: 1.2rem;
  color: var(--primary, #2563eb);
  transition: transform 0.3s ease, color 0.3s ease;
}

.subtab-item:hover {
  background: #eef2ff;
  border-color: var(--primary, #2563eb);
  color: var(--primary, #2563eb);
  transform: translateY(-2px);
}

.subtab-item:hover i {
  color: var(--primary, #2563eb);
  transform: scale(1.15);
}

/* === Active State === */
.subtab-item.active {
  background: var(--primary, #2563eb);
  color: #fff;
  border-color: var(--primary-dark, #1e40af);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);
}

.subtab-item.active i {
  color: #fff;
  transform: scale(1.1);
}

/* Animated Bottom Bar */
.subtab-item::after {
  content: "";
  position: absolute;
  bottom: 5px;
  left: 10%;
  width: 0;
  height: 2px;
  background: #fff;
  border-radius: 1px;
  transition: width 0.3s ease;
}

.subtab-item.active::after {
  width: 80%;
}

/* === Subtab Content (fade in) === */
.subtab-content {
  animation: fadeInUp 0.4s ease forwards;
  opacity: 0;
  transform: translateY(8px);
}

@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* === Mobile Responsive === */
@media (max-width: 768px) {
  .subtabs {
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: thin;
    -ms-overflow-style: none;
  }
  .subtabs::-webkit-scrollbar {
    display: none;
  }

  .subtab-item {
    flex: 0 0 auto;
    white-space: nowrap;
    padding: 8px 12px;
    font-size: 13px;
    min-width: auto;
  }
}

/* ===== Icon Button (used for show/hide API key, etc.) ===== */
.icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 1px solid var(--border, #e5e7eb);
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 1px 2px rgba(0,0,0,0.04);
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.icon-btn i {
  font-size: 1.1rem;
  color: var(--muted, #6b7280);
  transition: transform 0.25s ease, color 0.25s ease;
  line-height: 1;
}

/* Hover / Focus */
.icon-btn:hover {
  background: #f9fafb;
  border-color: var(--primary, #2563eb);
  transform: translateY(-1px);
}
.icon-btn:hover i {
  color: var(--primary, #2563eb);
  transform: scale(1.06);
}
.icon-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
  border-color: var(--primary, #2563eb);
}

/* Active press */
.icon-btn:active {
  transform: translateY(0);
  box-shadow: 0 0 0 rgba(0,0,0,0);
}

/* Variant: danger (e.g., rotate/revoke key) */
.icon-btn.danger {
  border-color: #fecaca;
  background: #fff;
}
.icon-btn.danger:hover {
  background: #fef2f2;
  border-color: #ef4444;
}
.icon-btn.danger i {
  color: #b91c1c;
}
.icon-btn.danger:hover i {
  color: #ef4444;
}

/* Disabled state */
.icon-btn[disabled],
.icon-btn.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* If you place icon-buttons in a row with inputs */
.input-with-action {
  display: flex;
  align-items: center;
  gap: 6px;
}
.input-with-action input {
  flex: 1 1 auto;
}

</style>

